import { MenuProps } from "antd"
import { Dropdown } from "antd"
import React from "react"
import { Link } from "react-router-dom"
import ArrowDown from "../../../assets/images/dropArrow.svg"

const items: MenuProps["items"] = [
    {
        key: "Events",
        label: (
            <Link rel="noopener noreferrer" to="/connect">
                Events
            </Link>
        ),
    },
    {
        key: "Volunteer",
        label: (
            <Link rel="noopener noreferrer" to="/connect?section=volunteer">
                Volunteer
            </Link>
        ),
    },
    {
        key: "Partnership Opportunities",
        label: (
            <Link
                rel="noopener noreferrer"
                to="/connect?section=partnership-opportunities"
            >
                Partnership Opportunities
            </Link>
        ),
    },
]
const prepareItems: MenuProps["items"] = [
    {
        key: "GRE",
        label: <Link to={"/gre"}>GRE Prep Program</Link>,
    },
    {
        key: "How Our Course Works",
        label: <Link to="/how-our-course-works">How Our Course Works</Link>,
    },
    {
        key: "Free Test",
        label: <Link to="/freetest">Free Practice Exam</Link>,
    },
    {
        key: "Partners",
        label: <Link to="/partners">Tuition Discounts</Link>,
    },
    {
        key: "FAQ",
        label: <Link to={"/faq"}>FAQs</Link>,
    },
]
const adviceItems: MenuProps["items"] = [
    {
        key: "What You Should Know Before Applying",
        label: (
            <Link rel="noopener noreferrer" to="/foresee-items">
                What You Should Know Before Applying
            </Link>
        ),
    },
    {
        key: "Timeline",
        label: (
            <Link rel="noopener noreferrer" to="/timeline">
                Timeline
            </Link>
        ),
    },
    {
        key: "Do I Need the GRE?",
        label: (
            <Link rel="noopener noreferrer" to="/gre-need">
                Do I Need the GRE?
            </Link>
        ),
    },
    {
        key: "Choosing Between the GRE and GMAT",
        label: (
            <Link rel="noopener noreferrer" to="/gre-or-gmat">
                Choosing Between the GRE and GMAT
            </Link>
        ),
    },
]
const AboutUsItems: MenuProps["items"] = [
    {
        key: "1",
        label: <Link to="/our-mission">Our Mission</Link>,
    },
    {
        key: "2",
        label: <Link to="/meet-our-leaders">Our Board of Directors</Link>,
    },
    {
        key: "3",
        label: <Link to="/annual-report">Annual Report</Link>,
    },
    {
        key: "4",
        label: (
            <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://givebutter.com/Vo9aqn"
            >
                Support Us/Donate
            </a>
        ),
    },
    {
        key: "5",
        label: <Link to="/contact-us">Contact Us</Link>,
    },
]
const NavDropDowns = () => {
    return (
        <>
            <Dropdown
                menu={{ items }}
                dropdownRender={(menu) => (
                    <div className="dropdown-content header-dropdown-content">
                        {menu}
                    </div>
                )}
                className="TopBarDropDown"
                placement="bottomLeft"
                arrow={{ pointAtCenter: true }}
            >
                <div className="DDcontent">
                    <span className="positionY">
                        <p className="label">CONNECT</p>
                        <img
                            src={ArrowDown}
                            alt="arrowDown"
                            className="arrowDown"
                        />
                    </span>
                </div>
            </Dropdown>
            <Dropdown
                menu={{ items: prepareItems }}
                dropdownRender={(menu) => (
                    <div className="dropdown-content header-dropdown-content">
                        {menu}
                    </div>
                )}
                className="TopBarDropDown"
                placement="bottomLeft"
                arrow={{ pointAtCenter: true }}
            >
                <div className="DDcontent">
                    <span className="positionY">
                        <p className="label">GRE PREP</p>
                        <img
                            src={ArrowDown}
                            alt="arrowDown"
                            className="arrowDown"
                        />
                    </span>
                </div>
            </Dropdown>
            <Dropdown
                menu={{ items: adviceItems }}
                dropdownRender={(menu) => (
                    <div className="dropdown-content header-dropdown-content">
                        {menu}
                    </div>
                )}
                className="TopBarDropDown"
                placement="bottomLeft"
                arrow={{ pointAtCenter: true }}
            >
                <div className="DDcontent">
                    <span className="positionY">
                        <p className="label">ADVICE</p>
                        <img
                            src={ArrowDown}
                            alt="arrowDown"
                            className="arrowDown"
                        />
                    </span>
                </div>
            </Dropdown>
            <Dropdown
                menu={{ items: AboutUsItems }}
                dropdownRender={(menu) => (
                    <div className="dropdown-content header-dropdown-content">
                        {menu}
                    </div>
                )}
                className="TopBarDropDown"
                placement="bottomLeft"
                arrow={{ pointAtCenter: true }}
            >
                <div className="DDcontent">
                    <span className="positionY">
                        <p className="label">ABOUT US</p>
                        <img
                            src={ArrowDown}
                            alt="arrowDown"
                            className="arrowDown"
                        />
                    </span>
                </div>
            </Dropdown>
        </>
    )
}

export default NavDropDowns
